

























import Vue from 'vue'
import i18n from 'vue-i18n'
import { Component, Prop } from 'vue-property-decorator'

import { GroupedBotProperty } from '../../../../../../../../../../../BotProperties/components/Properties/types'
import { PropertyAction } from '../../../../../../Action/logic/Actions/PropertyAction/PropertyAction'

@Component
export default class PropertyValue extends Vue {
  @Prop() action!: PropertyAction

  @Prop() properties!: Array<GroupedBotProperty>

  @Prop() i18n!: i18n

  get propertyName(): string | undefined {
    return this.properties.find((p) => p.id === this.action.property_index)?.name
  }
}
